export default {
  presenter: 'becvarik',
  title: 'Virtuály a kontejnery',
  subtitle: 'mírně pokročilí',
  text: `
Docker změnil náš svět během 5 minut. Kam nás přivedl a proč? Pojďme se podívat do útrob
kernelu a zjisti jak se liší jenoduchý kontejner od primitivního virtuálního stroje KVM.
Pojďmě tyto věci zkusit propojit a vysvětlit si, že i kontejner může být velká a pomalá
bestie a že i virtuální stroj nás může překvapit svou svižností, lehkostí a škálovatelností.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/becvarik-virtualy.js